import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useCompanyData } from "../../../lib/useMockData";

export default function ValuesSection() {
  const { valuesData } = useCompanyData();
  return (
    <section className="py-20 md:py-28 bg-airdoa-white">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-14">
              <p className="section-label mb-3">{valuesData.label}</p>
              <h2 className="section-title">{valuesData.title}</h2>
              <p className="section-subtitle">{valuesData.subtitle}</p>
            </div>
          </ScrollReveal>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {valuesData.items.map((item, idx) => (
              <ScrollReveal key={item.title} direction="up" delay={idx * 120}>
                <div className="p-7 md:p-8 bg-airdoa-cream rounded-lg h-full flex flex-col">
                  <div className="w-12 h-12 flex items-center justify-center text-airdoa-gold mb-5">
                    <i className={`${item.icon} text-2xl`} />
                  </div>
                  <h3 className="text-lg font-serif font-semibold text-airdoa-navy mb-4">
                    {item.title}
                  </h3>
                  <p className="text-sm text-airdoa-gray leading-[1.9] flex-1">
                    {item.desc}
                  </p>
                </div>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}